import store from '../store'
import endpoints from '@api/repository';
import api from '@api/index';

const TourHelper = {
    isVisible(el) {
        var element = document.querySelector(el);
        return element && element.style.display != 'none' && element.offsetWidth > 0 && element.offsetHeight > 0;
    },

    prepareSteps(propertyKey, steps) {
        var self = this;

        return steps.map(singleStep => {
            var step = {
                id: singleStep.id,
                title: singleStep.title,
                text: singleStep.description,
                attachTo: {
                    element: singleStep.el,
                    on: singleStep.position || 'bottom'
                },
                showOn() {
                    if (singleStep.el) {
                        return self.isVisible(singleStep.el) ? true : false;
                    }
                    return true
                },
                buttons: [],
            };

            if (steps.indexOf(singleStep) == 0) step.buttons.push({
                text: 'Skip',
                action() {
                    this.complete();
                    self.completeTour(propertyKey);

                }
            });
            // if (singleStep.videoLink) step.buttons.push({
            //     text: 'Watch Video',
            //     action() {
            //         let a = document.createElement('a');
            //         a.target = '_blank';
            //         a.href = singleStep.videoLink;
            //         a.click();
            //     }
            // });

            if (steps.indexOf(singleStep) != 0) step.buttons.push({
                text: 'Back',
                action() {
                    this.back();

                }
            });

            // if (steps.indexOf(singleStep) +1 == steps.length) 

            // var elementExists = document.querySelector(singleStep.el)
            if (steps.indexOf(singleStep) + 1 != steps.length) {
                var nextStep = steps[steps.indexOf(singleStep) + 1];
                var isNextElementVisible = !nextStep.el || self.isVisible(nextStep.el);
                var isNextElementLast = steps.indexOf(nextStep) + 1 == steps.length;
                step.buttons.push({
                    text: !isNextElementVisible && isNextElementLast ? 'Finish' : 'Next',
                    action() {
                        if (!isNextElementVisible && isNextElementLast) {
                            this.complete();
                            self.completeTour(propertyKey);
                        } else {
                            this.next();
                        }
                    }
                });
            }

            if (steps.indexOf(singleStep) + 1 == steps.length) step.buttons.push({
                text: 'Finish',
                action() {
                    this.complete();
                    self.completeTour(propertyKey);
                }
            });
            return step;


        });
    },

    isEligible: (propertyKey) => {

        var propertyKeyExists = propertyKey in store.getters.tourFlags;
        var propertyKeyTrue = store.getters.tourFlags[propertyKey] == true;
        return !propertyKeyExists || !propertyKeyTrue;
    },

    async startTour(context, propertyKey, steps) {
        await this.getTourHistory();
        if (!this.isEligible(propertyKey)) return;
        if (steps.length == 0) return;

        var tourSteps = this.prepareSteps(propertyKey, steps);
        const tour = context.$shepherd({
            useModalOverlay: true,
            defaultStepOptions: {
                classes: "custom-shepherd",
                scrollTo: true,
                scrollToHandler: function (e) {
                    if (e)
                        e.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                }

            },
        });

        tour.addSteps(tourSteps);
        tour.start();

    },
    // API calls

    essentials: {
        setLoading: () => store.dispatch('setLoading'),
        accessToken: store.getters.accessToken,
        handleErrorsFunction: (e) => console.log(e),
    },

    async getTourHistory() {
        if (store.getters.tourFlags != null) return;
        var url = endpoints.tourHistory + store.getters.currentUser.id + "/";
        var response = await api.call(this.essentials, url);
        store.dispatch('setTourFlags', response.flags);
        return;
    },

    async completeTour(propertyKey) {
        var tourFlags = store.getters.tourFlags;
        // update tourFlags variable and send to backend
        tourFlags[propertyKey] = true;
        // save response to frontend store
        var url = endpoints.tourHistory + store.getters.currentUser.id + '/';
        var body = {
            flags: tourFlags
        };
        var response = await api.call(this.essentials, url, api.Methods.PATCH, body);
        if (response) {
            store.dispatch('setTourFlags', response.flags);
        }
    },

    async resetTour() {
        var url = endpoints.tourHistory + store.getters.currentUser.id + '/';
        var response = await api.call(this.essentials, url, api.Methods.PATCH, {
            flags: {}
        });
        if (response) {
            console.log(response);
            store.dispatch('setTourFlags', response.flags);
            return true;
        }
        return false;
    }
}

export default TourHelper;